var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.reports },
    [
      _vm.type === "project"
        ? _c("projects-report-page", { attrs: { "report-type": "time" } })
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "month"
        ? _c("monthes-report-page", { attrs: { "report-type": "time" } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }